import {
  Bed,
  Brain,
  CalendarBlank,
  CaretLeft,
  ChartLineUp,
  ChatCircleDots,
  CheckCircle,
  Circle,
  ClipboardText,
  Compass,
  Heart,
  type Icon,
  Lightning,
  ListChecks,
  MagnifyingGlass,
  Moon,
  PencilSimple,
  Plus,
  Pulse,
  Question,
  SpeakerHigh,
  SpeakerSlash,
  Sun,
  Target,
} from "@phosphor-icons/react";

// No AI sparkle anywhere: it is banned in HealthOS. The SDK passes "search"
// and "chevronLeft"; suggestion/prediction names map to plain Phosphor glyphs.
const ICONS: Record<string, Icon> = {
  search: MagnifyingGlass,
  chevronleft: CaretLeft,
  heart: Heart,
  check: CheckCircle,
  bed: Bed,
  pulse: Pulse,
  sun: Sun,
  moon: Moon,
  brain: Brain,
  list: ListChecks,
  question: Question,
  chart: ChartLineUp,
  calendar: CalendarBlank,
  compass: Compass,
  navigate: Compass,
  pencil: PencilSimple,
  feedback: PencilSimple,
  lightning: Lightning,
  bolt: Lightning,
  target: Target,
  plus: Plus,
  chat: ChatCircleDots,
  ask: ChatCircleDots,
  clipboard: ClipboardText,
  survey: ClipboardText,
  "speaker-high": SpeakerHigh,
  "speaker-slash": SpeakerSlash,
};

export function PrybarIcon({ name }: { name: string }) {
  const Resolved = ICONS[name.toLowerCase()] ?? Circle;
  return <Resolved weight="regular" />;
}
